<ion-header>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-icon
        (click)="dismiss()"
        (keydown)="dismiss()"
        name="close"
        style="color: white"
      ></ion-icon>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content scroll-y="false">
  <ion-row class="ion-align-items-center ion-margin-top">
    <ion-col size="1">
      @if (index < photos.length - 1) {
        <ion-icon
          (click)="nextSlide()"
          (keydown)="nextSlide()"
          name="chevron-back-outline"
        ></ion-icon>
      }
    </ion-col>
    <ion-col size="10">
      <img
        [src]="sanitizer.bypassSecurityTrustResourceUrl(enCours.webviewPath)"
        [class.contain]="lectureSeule"
        alt="photo"
        />
      </ion-col>
      <ion-col size="1">
        @if (index > 0) {
          <ion-icon
            (click)="prevSlide()"
            (keydown)="prevSlide()"
            name="chevron-forward-outline"
          ></ion-icon>
        }
      </ion-col>
    </ion-row>
  </ion-content>
  @if (!lectureSeule) {
  <ion-footer>
    <ion-grid>
      <ion-row>
        <ion-col class="text-center">
          <ion-button
            (click)="delete(enCours)"
            (keydown)="delete(enCours)"
            class="custom"
            fill="block"
            >
            <ion-icon class="mr-3" name="trash-outline"></ion-icon>
            Supprimer
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-footer>
  }
